import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import Main from './pages/Main';
import MainMobile from './pages/MainMobile';
import { GoogleTagManagerProvider } from '@tracktor/react-google-tag-manager';

function App() {
  return (
    <GoogleTagManagerProvider id="GTM-KTGWC4CZ">
      <Router>
        <Routes>
          <Route path="/" element={window.innerWidth > 1140 ? <Main /> : <MainMobile />} />
        </Routes>
      </Router>
    </GoogleTagManagerProvider>
  );
}

export default App;
